import { SALES_NUMBER } from "@/constants";

import { sendAnalyticData } from "../monitoring/analytics";
import { handleOpenLink } from "../platform";

export const onChatSupport = async ({
  path,
  message = "Hi! I would like to speak to sales about booking a new appointment through your web application.",
  phoneNumber = SALES_NUMBER,
}: {
  path: string;
  message?: string;
  phoneNumber?: string;
}) => {
  const url = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;

  await handleOpenLink(url);
  sendAnalyticData({
    name: "wa_sales_button_click",
    values: {
      path,
    },
  });
};
